$.fn.boldFirstWord = function() {
    $(this).each(function(){
        var $link = $(this),
            clearText = $link.text().trim(),
            splitOnSpace = clearText.split(' '),
            firstWord = splitOnSpace[0];

        $link.html(clearText.split(firstWord).join('<strong>' + firstWord + '</strong>'));
    });  
};